import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useInventoryService } from "./inventory.service";
import { inventoryQueryKeys } from "./inventory.queryKeys";

export function useInventoryEntriesQuery(propertyTicker: string, locale: string, enabled = true) {
  const inventoryService = useInventoryService();

  return useQuery({
    queryKey: inventoryQueryKeys.list(propertyTicker, locale),
    queryFn: () => inventoryService.getInventoryEntries(propertyTicker, locale),
    enabled: enabled && !!propertyTicker,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
}

export function useCurrentInventoryStateQuery(propertyTicker: string, enabled = true) {
  const inventoryService = useInventoryService();

  return useQuery({
    queryKey: inventoryQueryKeys.state(propertyTicker),
    queryFn: () => inventoryService.getCurrentInventoryState(propertyTicker),
    enabled: enabled && !!propertyTicker,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
}

export function useInvalidateInventoryCaches() {
  const queryClient = useQueryClient();
  return useCallback(() => queryClient.removeQueries({ queryKey: inventoryQueryKeys.all }), [
    queryClient,
  ]);
}
